export default function formatStringToNumDate(date) {
    //console.log("received date: "+date)
    //will take Fri Sep 11 00:00:00 EDT 2020 and turn into 9-11-2020
    var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

    //console.log("date: " + d);
    if (month.length < 2) {
        month = "0" + month
    }

    if (day.length < 2) {
        day = "0" + day;
    }
    return [year, month, day].join("-");
}
